import { createStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

export const styles = (theme: Theme) => createStyles({
	headerActions: {
		textAlign: 'right',
		marginLeft: '-57px'
	},
	vertHeaderActions: {
		textAlign: 'center',
		marginLeft: '-8px'
	},
	editText:{
		marginTop: theme.spacing.unit * -0.5,
		textDecoration:'none',
		width:'35px'
		},
		editTextIcons:{
		marginTop: theme.spacing.unit * -0.5,
		},
	 root: {
		flexShrink: 0,
		color: theme.palette.text.secondary,
	},
	wrapperMain: {
		height: "auto", backgroundColor: theme.palette.common.white, paddingRight: "20px", paddingLeft: "20px", fontSize: "18px"
	},
	borderDefault: {
		border: "1px solid #DDDDDD",
		borderRadius: "5px"
	},
	marginTop10: {
		marginTop: theme.spacing.unit
	},
	incompleteDraft:{
		position: "absolute",
    	marginTop: "28px",
    	marginLeft: "-80px",
	}
});